import { Component, OnInit, Inject, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { log } from 'console';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import { getUnique, getUniqueByKey, yearWeekToDate } from 'src/app/constants';
import { DeleteBtnCellRender } from 'src/app/configuration-shifts/breaks-detailview/review-changes/review-container.component/delete-btn-cell-render';
import { DeleteBreaksComponent } from 'src/app/configuration-shifts/breaks-detailview/delete-breaks/delete-breaks.component';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';


@Component({
  selector: 'app-add-parts-group-dialog',
  templateUrl: './add-parts-group-dialog.component.html',
  styleUrls: ['./add-parts-group-dialog.component.scss']
})
export class AddPartsGroupDialogComponent implements OnInit {
  addPartsGroupEventEmitter = new EventEmitter();
  editShiftsEventEmitter = new EventEmitter();
  rowData = [];
  @ViewChild('osPartsGrid') osPartsGrid;

  gridOptions = {} as any;
  columnDefs;
  defaultColDef;
  rowSelection;
  context: any;
  editType;
  suppressClickEdit = true;
  errorMessage1: any;
  errorMessageUpdate = false;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  dock: any;
  popupname: any;
  groupName: any;
  countCycle:any;
  dayWeek: any;
  inNextDay: any;
  dataItem: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  shiftNumbers: any[] = [];
  errorMessage: any;
  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    dock: [''],
    groupName: ['', Validators.required],
    countCycle: ['', Validators.required],
    // partNo :['', Validators.required],
    // kanbanNo:['', Validators.required],

  },
  );
  warningMessage: string;
  itContact: any;
  successMessage: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<AddPartsGroupDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {}
  
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {
    console.log(this.data.dock,'dockValue')
    this.addOrEditform.controls.groupName.setValue(this.data.groupName);
    this.addOrEditform.controls.countCycle.setValue(this.data.cycleCount);
    this.addOrEditform.controls.dock.setValue(this.data.dock);
    let fromHoursHH: number | undefined, fromMinutesMM: number | undefined
    // this.rowData = [
    //   {'parts_no':'901150616600','kanban':'6013'},
    //   {'parts_no':'901150616601','kanban':'6013'},
    //   {'parts_no':'901150616602','kanban':'6013'},
    // ];
    this.business_entity = localStorage.getItem('namcvalue');
    // this.shiftNumbers = [
    //   { value: 1 },
    //   { value: 2 },
    //   { value: 3 }
    // ];
   
    console.log("data---", this.data);
    console.log("data---1", this.data.dock);
    this.addOrEditform.patchValue({
      // fromHoursHH: fromHoursHH,
      // fromMintuesMM: fromMinutesMM,
      // toHoursHH: toHoursHH,
      // toMintuesMM: toMinutesMM,
      dock: this.addOrEdit.dock.value
    });
    if (this.data?.mode === 'edit') {
      // if (this.data.data?.dock) {
      //   this.addOrEdit.dock.setValue(
      //     this.data.data.dock
      //   );
      // }
    }
  }
  
  submitted: boolean = false;
  
  addPartsGroupDetails() {
    this.addOrEditform.controls.dock.setValue(this.data.dock);

    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }
    console.log(this.addOrEdit,'addOrEdit')
    console.log(this.addOrEditform,'addOrEditform')
    const addEmittedData = {
      dock: this.addOrEdit.dock.value.dock,
      groupName: this.addOrEdit.groupName.value,
      countCycle: this.addOrEdit.countCycle.value,
    };
    console.log(addEmittedData,'addEmittedData')
    this.addPartsGroupEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }

  editPartsGroupDetails() {
    console.log(this.addOrEdit,'addOrEdit')
    console.log(this.addOrEditform,'addOrEditform')
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    const editEmittedData = {
      partNo: this.addOrEdit.partNo.value.item_id ?? this.addOrEdit.partNo.value,
      kanbanNo: this.addOrEdit.kanbanNo.value.kanban ?? this.addOrEdit.kanbanNo.value,
      groupName: this.addOrEdit.groupName.value,
      countCycle: this.addOrEdit.countCycle.value,
    };
    let resultArray = {
      parts_no: editEmittedData.partNo,
      kanban: editEmittedData.kanbanNo,
    };

    console.log(editEmittedData, 'editEmittedData');

    console.log(this.rowData,'rowdata')
    console.log(this.rowData.push(resultArray),'rowdataPush')
    this.osPartsGrid.gridOptions.api.setRowData(this.rowData);

    this.editShiftsEventEmitter.emit(editEmittedData);
  }
  
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();
    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  hideSpinner() {
    this.spinner.hide();
  }

  callRespectiveFunction() {
    if (this.data?.mode === 'edit') {
      this.editPartsGroupDetails();
    } else {
      console.log("add function is called");

      this.addPartsGroupDetails();
    }
  }

 
  onPartNoChange(): void {
    const part_no = this.addOrEditform.controls.partNo?.value;
    console.log(part_no, 'part_no');
  
    // Disable the kanban dropdown
    this.addOrEditform.controls.kanbanNo.disable();
  
    if (part_no) {
      // Find the item in qpcPartsList matching the part number
      const item = this.data.qpcPartsList?.find((entry) => entry.item_id === part_no);
      console.log(item, 'item');
  
      // If an item is found, set the kanban value
      if (item) {
        // Set the kanban value in the form
        this.addOrEditform.controls.kanbanNo.setValue(item.kanban);
      }
    }
  }
  onKanbanChange(): void {
    const kanban = this.addOrEditform.controls.kanbanNo?.value;
    console.log(kanban, 'kanban');
  
    // Disable the part number dropdown
    this.addOrEditform.controls.partNo.disable();
  
    if (kanban) {
      // Find the item in qpcPartsList matching the kanban number
      const item = this.data.qpcPartsList?.find((entry) => entry.kanban === kanban);
      console.log(item, 'item');
  
      // If an item is found, set the partNo value
      if (item) {
        // Set the partNo value in the form
        this.addOrEditform.controls.partNo.setValue(item.item_id);
      }
    }
  }
  
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');  
  }
}

